import React from "react";
import MerchantList from "../../../../components/list/MerchantList";

const MemberManagement = () => {
  return (
    <div>
       <MerchantList/> 
    </div>
  );
};

export default MemberManagement;
